import { useTourListActions } from "../Providers/TourListProvider";

const SearchBar = ({ searchValue, setSearchValue }) => {
  const { dispatch } = useTourListActions();
  //const [value, setValue] = useState("");
  const changeHandler = (e) => {
    dispatch({ type: "SEARCH_TOUR", event: e.target.value });
    setSearchValue(e.target.value);
  };
  return (
    <div className="w-full md:w-1/3">
      <div className="text-xs"> جستجوی تور : </div>
      <input
        className="w-full border border-neutral-300 min-h-[38px] mt-2 rounded px-2 focus-visible:border-blue-500 focus-visible:border-2 outline-none text-slate-500"
        type="text"
        placeholder="نام تور"
        onChange={changeHandler}
        value={searchValue}
      />
    </div>
  );
};

export default SearchBar;
